export enum ORGANIZATION_TAB {
  MPA = 'mpa',
  MESSAGING = 'messaging',
  FORMS = 'forms',
  MINISTRY_SCHEDULER = 'ministry-scheduler',
  MASS_INTENTIONS = 'mass-intentions',
  ADORATION = 'adoration',
  FACILITY_SCHED = 'facility-sched',
  CAMINO = 'camino',
  DIOCESE_INFO = 'diocese-info',
  ORG_ADMINS = 'org-admins',
  DIRECT_MESSAGES = 'direct-messages',
  GROUP_ADMINS = 'group-admins',
  EVA_SYNC = 'eva-sync',
}

export const TAB_LABELS: Record<ORGANIZATION_TAB, string> = {
  [ORGANIZATION_TAB.MPA]: 'myParish',
  [ORGANIZATION_TAB.MINISTRY_SCHEDULER]: 'Ministry Sched',
  [ORGANIZATION_TAB.MASS_INTENTIONS]: 'Mass Intentions',
  [ORGANIZATION_TAB.ADORATION]: 'Adoration',
  [ORGANIZATION_TAB.FACILITY_SCHED]: 'Facility Sched',
  [ORGANIZATION_TAB.CAMINO]: 'Camino',
  [ORGANIZATION_TAB.DIOCESE_INFO]: 'Diocese Info',
  [ORGANIZATION_TAB.ORG_ADMINS]: 'Org Admins',
  [ORGANIZATION_TAB.GROUP_ADMINS]: 'Group & List Admins',
  [ORGANIZATION_TAB.MESSAGING]: 'Messaging',
  [ORGANIZATION_TAB.DIRECT_MESSAGES]: 'Direct Messages',
  [ORGANIZATION_TAB.FORMS]: 'Forms',
  [ORGANIZATION_TAB.EVA_SYNC]: 'Eva Sync',
};
